import src from "IMAGE";
export default { src, width: 2303, height: 420, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAAIUlEQVR42mModQ/aEGnNU8XAwKAGxEFAHAjE0UAcCsSxAGPjBK9t8H7qAAAAAElFTkSuQmCC"};
